export const invoiceTranslations = {
  ar: {
    title: "مولد الفواتير الذكي",
    subtitle: "أنشئ فواتير احترافية بسهولة مع معاينة فورية وخيارات تخصيص متقدمة. قوالب احترافية متوافقة مع أنظمة ATS.",
    selectTemplate: "اختر قالب الفاتورة",
    customize: "تخصيص الفاتورة",
    preview: "معاينة الفاتورة",
    download: "تنزيل الفاتورة",
    backToHome: "العودة للصفحة الرئيسية",
    tabs: {
      basic: "معلومات الشركة",
      client: "معلومات العميل",
      items: "الأصناف والخدمات",
      summary: "الملخص والإعدادات"
    },
    basic: {
      companyInfo: "معلومات الشركة",
      companyName: "اسم الشركة",
      companyNamePlaceholder: "أدخل اسم الشركة",
      companyEmail: "البريد الإلكتروني",
      companyEmailPlaceholder: "company@example.com",
      companyPhone: "رقم الهاتف",
      companyPhonePlaceholder: "+966 50 000 0000",
      companyAddress: "عنوان الشركة",
      companyAddressPlaceholder: "أدخل عنوان الشركة الكامل",
      companyLogo: "شعار الشركة",
      uploadLogo: "رفع شعار",
      changeLogo: "تغيير الشعار",
      removeLogo: "إزالة الشعار",
      invoiceInfo: "معلومات الفاتورة",
      invoiceNumber: "رقم الفاتورة",
      invoiceNumberPlaceholder: "INV-2024-001",
      currency: "العملة",
      invoiceDate: "تاريخ الفاتورة",
      dueDate: "تاريخ الاستحقاق"
    },
    client: {
      clientInfo: "معلومات العميل",
      clientName: "اسم العميل",
      clientNamePlaceholder: "أدخل اسم العميل",
      clientEmail: "البريد الإلكتروني",
      clientEmailPlaceholder: "client@example.com",
      clientPhone: "رقم الهاتف",
      clientPhonePlaceholder: "+966 50 000 0000",
      clientAddress: "عنوان العميل",
      clientAddressPlaceholder: "أدخل عنوان العميل الكامل",
      shippingInfo: "معلومات الشحن",
      copyFromClient: "نسخ من العميل",
      shippingName: "اسم المستلم",
      shippingNamePlaceholder: "أدخل اسم المستلم",
      shippingEmail: "البريد الإلكتروني",
      shippingEmailPlaceholder: "shipping@example.com",
      shippingPhone: "رقم الهاتف",
      shippingPhonePlaceholder: "+966 50 000 0000",
      shippingAddress: "عنوان الشحن",
      shippingAddressPlaceholder: "أدخل عنوان الشحن الكامل"
    },
    items: {
      title: "الأصناف والخدمات",
      addItem: "إضافة صنف",
      description: "الوصف",
      descriptionPlaceholder: "أدخل وصف الصنف أو الخدمة",
      quantity: "الكمية",
      price: "السعر",
      notes: "ملاحظات",
      optional: "اختياري",
      notesPlaceholder: "أدخل ملاحظات إضافية (اختياري)",
      subtotal: "المجموع الفرعي",
      removeItem: "حذف الصنف",
      emptyTitle: "لا توجد أصناف مضافة",
      emptyDescription: "ابدأ بإضافة الأصناف أو الخدمات التي تريد تضمينها في الفاتورة",
      addFirstItem: "إضافة أول صنف",
      summary: "ملخص الأصناف",
      totalItems: "إجمالي الأصناف",
      totalQuantity: "إجمالي الكمية",
      totalAmount: "إجمالي المبلغ"
    },
    summary: {
      calculations: "الحسابات",
      taxRate: "نسبة الضريبة",
      taxRateHelp: "أدخل نسبة الضريبة المطبقة على الفاتورة",
      discount: "الخصم",
      currency: "ريال",
      discountHelp: "أدخل مبلغ الخصم المطبق على الفاتورة",
      notes: "ملاحظات الفاتورة",
      notesPlaceholder: "أدخل ملاحظات إضافية للفاتورة",
      notesHelp: "يمكن إضافة ملاحظات خاصة أو شروط إضافية",
      paymentTerms: "شروط الدفع",
      paymentTermsLabel: "شروط الدفع",
      paymentTermsPlaceholder: "أدخل شروط الدفع المطبقة",
      paymentTermsHelp: "حدد شروط الدفع والشروط الخاصة بالفاتورة",
      quickTemplates: "قوالب سريعة لشروط الدفع",
      generateDemo: "توليد بيانات تجريبية",
      clearData: "مسح جميع البيانات",
      dataManagement: "إدارة البيانات",
      helpfulTips: "نصائح مفيدة",
      helpfulTipsText: "استخدم \"توليد بيانات تجريبية\" لملء الفاتورة ببيانات نموذجية، أو \"مسح جميع البيانات\" لبدء فاتورة جديدة من الصفر.",
      templates: {
        net30Title: "صافي 30 يوم",
        net30: "الدفع خلال 30 يوم من تاريخ الفاتورة",
        net15Title: "صافي 15 يوم",
        net15: "الدفع خلال 15 يوم من تاريخ الفاتورة",
        dueOnReceiptTitle: "الدفع عند الاستلام",
        dueOnReceipt: "الدفع مطلوب عند استلام الفاتورة",
        customTitle: "شروط مخصصة",
        custom: "أدخل شروط الدفع الخاصة بك"
      }
    },
    actions: {
      clearData: "مسح جميع البيانات",
      resetLayout: "إعادة تعيين التخطيط",
      fullPreview: "معاينة كاملة",
      downloadPDF: "تنزيل PDF",
      generateDemo: "توليد بيانات تجريبية",
      printPreview: "طباعة المعاينة"
    },
    previewControls: {
      showPreview: "إظهار المعاينة",
      hidePreview: "إخفاء المعاينة",
      print: "طباعة",
      download: "تنزيل PDF",
      fullScreen: "ملء الشاشة",
      showLogo: "إظهار الشعار",
      hideLogo: "إخفاء الشعار"
    }
  },
  en: {
    title: "Smart Invoice Generator",
    subtitle: "Create professional invoices easily with real-time preview and advanced customization options. Professional templates compatible with ATS systems.",
    selectTemplate: "Choose Invoice Template",
    customize: "Customize Invoice",
    preview: "Invoice Preview",
    download: "Download Invoice",
    backToHome: "Back to Home",
    tabs: {
      basic: "Company Information",
      client: "Client Information",
      items: "Items & Services",
      summary: "Summary & Settings"
    },
    basic: {
      companyInfo: "Company Information",
      companyName: "Company Name",
      companyNamePlaceholder: "Enter company name",
      companyEmail: "Email",
      companyEmailPlaceholder: "company@example.com",
      companyPhone: "Phone",
      companyPhonePlaceholder: "+966 50 000 0000",
      companyAddress: "Company Address",
      companyAddressPlaceholder: "Enter complete company address",
      companyLogo: "Company Logo",
      uploadLogo: "Upload Logo",
      changeLogo: "Change Logo",
      removeLogo: "Remove Logo",
      invoiceInfo: "Invoice Information",
      invoiceNumber: "Invoice Number",
      invoiceNumberPlaceholder: "INV-2024-001",
      currency: "Currency",
      invoiceDate: "Invoice Date",
      dueDate: "Due Date"
    },
    client: {
      clientInfo: "Client Information",
      clientName: "Client Name",
      clientNamePlaceholder: "Enter client name",
      clientEmail: "Email",
      clientEmailPlaceholder: "client@example.com",
      clientPhone: "Phone",
      clientPhonePlaceholder: "+966 50 000 0000",
      clientAddress: "Client Address",
      clientAddressPlaceholder: "Enter complete client address",
      shippingInfo: "Shipping Information",
      copyFromClient: "Copy from Client",
      shippingName: "Recipient Name",
      shippingNamePlaceholder: "Enter recipient name",
      shippingEmail: "Email",
      shippingEmailPlaceholder: "shipping@example.com",
      shippingPhone: "Phone",
      shippingPhonePlaceholder: "+966 50 000 0000",
      shippingAddress: "Shipping Address",
      shippingAddressPlaceholder: "Enter complete shipping address"
    },
    items: {
      title: "Items & Services",
      addItem: "Add Item",
      description: "Description",
      descriptionPlaceholder: "Enter item or service description",
      quantity: "Quantity",
      price: "Price",
      notes: "Notes",
      optional: "Optional",
      notesPlaceholder: "Enter additional notes (optional)",
      subtotal: "Subtotal",
      removeItem: "Remove Item",
      emptyTitle: "No items added",
      emptyDescription: "Start by adding items or services you want to include in the invoice",
      addFirstItem: "Add First Item",
      summary: "Items Summary",
      totalItems: "Total Items",
      totalQuantity: "Total Quantity",
      totalAmount: "Total Amount"
    },
    summary: {
      calculations: "Calculations",
      taxRate: "Tax Rate",
      taxRateHelp: "Enter the tax rate applied to the invoice",
      discount: "Discount",
      currency: "SAR",
      discountHelp: "Enter the discount amount applied to the invoice",
      notes: "Invoice Notes",
      notesPlaceholder: "Enter additional notes for the invoice",
      notesHelp: "You can add special notes or additional terms",
      paymentTerms: "Payment Terms",
      paymentTermsLabel: "Payment Terms",
      paymentTermsPlaceholder: "Enter the payment terms applied",
      paymentTermsHelp: "Specify payment terms and special conditions for the invoice",
      quickTemplates: "Quick Payment Terms Templates",
      templates: {
        net30Title: "Net 30",
        net30: "Payment due within 30 days of invoice date",
        net15Title: "Net 15",
        net15: "Payment due within 15 days of invoice date",
        dueOnReceiptTitle: "Due on Receipt",
        dueOnReceipt: "Payment required upon receipt of invoice",
        customTitle: "Custom Terms",
        custom: "Enter your custom payment terms"
      }
    },
    actions: {
      clearData: "Clear All Data",
      resetLayout: "Reset Layout",
      fullPreview: "Full Preview",
      downloadPDF: "Download PDF",
      generateDemo: "Generate Demo Data",
      printPreview: "Print Preview"
    },
    previewControls: {
      showPreview: "Show Preview",
      hidePreview: "Hide Preview",
      print: "Print",
      download: "Download PDF",
      fullScreen: "Full Screen",
      showLogo: "Show Logo",
      hideLogo: "Hide Logo"
    }
  }
};

export default invoiceTranslations; 